export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id,
    codigo: item.codigo_rubro || "Código no disponible",  // Valor predeterminado en caso de que falte el código
    descripcion: item.descripcion_rubro || "Rubro disponible",  // Valor predeterminado
    ramo: item.su_ramo?.descripcion_ramo || "Ramo no disponible",  // Usar optional chaining para evitar errores si su_ramo es null o undefined
    web: item.rubro_show_web === 0 ? "✅" : "❌",
    app: item.rubro_show_app === 0 ? "✅" : "❌", 
  }));
